import { Box } from '@hivebrite/design-system/Box';

import { Select } from 'hb-react/shared/components/formik/components/inputs';

interface PeriodicityProps {
  enabled?: boolean;
  periodicities?: Array<{
    value: string;
    label: string;
  }>;
}

const Periodicity = ({ enabled, periodicities }: PeriodicityProps) =>
  enabled ? (
    <Box
      my={6}
      className="one-half palm--one-whole soft--left bordered--left border-color--mediumgray border-width--2"
    >
      <Select
        name="donation_order[periodicity]"
        label={s__('donations|I will give every...')}
        validate={{
          required: true,
        }}
        options={periodicities}
        isNotSearchable
        wrapperProps={{ mb: 0 }}
      />
    </Box>
  ) : null;

export default Periodicity;
